import React, { useCallback } from "react";
import { Button } from "react-bootstrap";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { divIcon, LatLngExpression } from "leaflet";
import "leaflet/dist/leaflet.css";
import "./leaflet-extended.css";
import { trackGaEvent } from "../../util/gtm";

export interface DefaultMarker {
    position: LatLngExpression;
    data: string[];
    url: string;
}

const generateIcon = () => {
    return divIcon({
        iconAnchor: [18, 45],
        iconSize: [35, 45],
        html: "",
    });
};

const generateMarkers = (item: DefaultMarker, index: number): JSX.Element => (
    <Marker
        key={`marker-${index}`}
        icon={generateIcon()}
        position={item.position}
    >
        <Popup>
            <a href={item.url} style={{ textDecoration: "none" }}></a>
            {item.data.map((item, i) => (
                <div key={`marker-inner-${i}`}>
                    <span key={i}>{item}</span>
                    <br />
                </div>
            ))}
        </Popup>
    </Marker>
);

export const DefaultMap: React.FC<{
    markers?: DefaultMarker[];
    latitude: number;
    longitude: number;
}> = (props) => {
    //const navUrl = `https://www.google.com/maps/search/?api=1&query=${props.latitude},${props.longitude}`;
    const navUrl = `https://www.google.com/maps/dir/?api=1&destination=${props.latitude},${props.longitude}`;

    return (
        <div className="position-relative">
            <MapContainer
                center={[props.latitude, props.longitude]}
                zoom={16}
                scrollWheelZoom={true}
                style={{ height: "300px" }}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {props.markers && <>{props.markers.map(generateMarkers)}</>}
            </MapContainer>
            <Button
                variant="secondary"
                size="sm"
                className="mt-2"
                href={navUrl}
                target="_blank"
            >
                Rutevejledning
            </Button>
        </div>
    );
};
